import { Division, UserWithBalanceAccounts } from "@models";
import React from "react";

type UserDetailsPageContextValue = {
	user: UserWithBalanceAccounts;
	division?: Division;
	triggerRefresh: () => void;
};

export default React.createContext<UserDetailsPageContextValue>({
	triggerRefresh: () => {},
} as UserDetailsPageContextValue);
